import styled from 'styled-components';
import {
    Card,
} from "@mui/material";

//Checkout Styles
export const CheckoutCardContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
`;

export const CheckoutContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    // display: grid !important;
    // grid-template-columns: 2.7fr 1.3fr !important;
    display: flex;
    gap: 30px;
`;

export const ItemsContainer = styled(Card) <{ $darkMode?: boolean; }>`
    border: 1px solid;
    border-radius: 4px !important;
    box-shadow: none !important;
    width: 67%;
    height: max-content;
    overflow: unset !important;
`;

export const SummaryContainer = styled(Card) <{ $darkMode?: boolean; }>`
    // background: pink !important;
    border: 1px solid;
    border-radius: 4px !important;
    box-shadow: none !important;
    width: 32%;
    height: max-content;
`;

export const OrderSummaryText = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-bottom: 1px solid;
    border-radius: 0px !important;
    box-shadow: none !important;

    font-size: 16px;
    font-weight: 600;
    padding: 15px;
`;

export const OrderHeaderContainer = styled(Card) <{ $darkMode?: boolean; }>`
    // background: var(--mainBGPrimaryColor) !important;
    border: none;
    border-bottom: 1px solid;
    border-radius: 0px !important;
    box-shadow: none !important;
    display: grid;
    grid-template-columns: 1fr 0.5fr;
    padding: 10px 15px;

    .productInfoText, .priceText {
        font-size: 0.775rem !important;
        font-weight: 700 !important;
        color: #878a99 !important;
        text-transform: uppercase;
    }

    .priceText {
        text-align: right;
    }
`;

export const SummaryItemsContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-bottom: 1px solid;
    border-radius: 0px !important;
    box-shadow: none !important;
    display: grid;
    grid-template-columns: 1fr 0.5fr;
    padding: 10px 15px;
    gap: 25px;
    align-items: center;

    .amountTitle, .amountValue {
        font-size: 0.80rem !important;
        font-weight: 600 !important;
    }

    .amountValue {
        text-align: right;

        &:first-of-type {
            align-self: start !important;
        }
    }
`;

export const LicenseContainer = styled(Card) <{ $darkMode?: boolean; }>`
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    column-gap: 10px;
    row-gap: 0px;
    width: 100% !important;
    display: grid;
    grid-template-columns: 1fr 3fr;
    // align-items: center;
    align-items: start;

    .itemsContent {
        display: grid;
        grid-template-columns: 1fr;
        gap: 5px;

        .licenseKeyText {
            font-size: 14px;
            font-weight: 600;
            // height: max-content !important;
        }

        .otherDetails {
            font-size: 0.80rem;
            font-weight: 600;
            color: #878a99 !important;
            height: max-content !important;
            display: flex;
            align-items: center;

            svg {
                width: 15px;
                height: 15px;
                margin: 0px 5px 0px 0px;
            }
        }
    }
`;

export const ImageContainer = styled(Card) <{ $darkMode?: boolean; }>`
    border: none;
    border-radius: 4px !important;
    box-shadow: none !important;
    padding: 7px;
    gap: 25px;
    width: max-content;
    height: max-content;
    grid-row: span 3;

    img {
        display: block;
        width: 60px;
    }
`;

export const GrandTotalContainer = styled(Card) <{ $darkMode?: boolean; }>`
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    display: grid;
    grid-template-columns: 1fr 0.5fr;
    padding: 10px 15px;

    .grandTotalText, .grandTotalValue {
        font-size: 0.80rem !important;
        font-weight: 700 !important;
    }

    .grandTotalValue {
        text-align: right;
    }
`;

//Billing Info Styles
export const BillingInfoContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 10px;
    column-gap: 25px;
    margin: 20px 0px 0px 0px;

    .span2Field {
        grid-column: span 2;
    }
`;

//Stripe Form Styles
export  const StripeFormContainer = styled(Card) <{ $darkMode?: boolean; }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;

    .nextPrevContainer {
        display: flex;
        justify-content: space-between;
    }
`;